import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { CompanyContextService } from '../../../services/company-context.service';
import { MembershipPlanChangeSettingsService } from '../../../services/membership-plan-change-settings.service';
import { PlanChangeSettingsSource } from '../../../../services/plan-change-settings.service';
import { PlanChangeSettingsComponent } from '../../../../shared/components/plan-change-settings/plan-change-settings.component';

/**
 * CWS-1598: the Membership Plan Changes tab on the super-admin company page.
 * Hosts the shared settings panel, pointed at the company the page is scoped
 * to, so the switch is a platform decision rather than a shop-admin one.
 */
@Component({
  selector: 'app-company-plan-change-settings',
  standalone: true,
  imports: [CommonModule, PlanChangeSettingsComponent],
  templateUrl: './company-plan-change-settings.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./company-plan-change-settings.component.scss'],
})
export class CompanyPlanChangeSettingsComponent implements OnInit, OnDestroy {
  private readonly context = inject(CompanyContextService);
  private readonly settingsService = inject(MembershipPlanChangeSettingsService);

  companyId = '';
  source: PlanChangeSettingsSource | null = null;

  private contextSub?: Subscription;

  ngOnInit(): void {
    this.contextSub = this.context.current$.subscribe(company => {
      const nextCompanyId = company?.id || '';
      if (nextCompanyId === this.companyId) {
        return;
      }
      this.companyId = nextCompanyId;
      this.source = nextCompanyId ? this.settingsService.forCompany(nextCompanyId) : null;
    });
  }

  ngOnDestroy(): void {
    this.contextSub?.unsubscribe();
  }
}
